import React from "react"

const CircleIcon = () => {
  return (
    <svg
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 1,
      }}
      xmlns="http://www.w3.org/2000/svg"
      width="140"
      height="140"
      viewBox="0 0 140 140"
      fill="none"
    >
      <circle
        cx="70"
        cy="70"
        r="66"
        stroke="white"
        strokeOpacity="0.2"
        strokeWidth="4"
        strokeLinejoin="round"
        strokeDasharray="1 4"
      />
      <circle
        cx="70"
        cy="70"
        r="66.5"
        stroke="#215368"
        strokeWidth="5"
        strokeLinejoin="round"
        strokeDasharray="2 48"
      />
    </svg>
  )
}

export default CircleIcon
